// extracted by mini-css-extract-plugin
export default {"main-container":"DashboardIndex_main-container__H7FaJ"};